/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    LoginRequest,
    LoginRequestFromJSON,
    LoginRequestToJSON,
    LoginResponse,
    LoginResponseFromJSON,
    LoginResponseToJSON,
    LogoutResponse,
    LogoutResponseFromJSON,
    LogoutResponseToJSON,
    Privileges,
    PrivilegesFromJSON,
    PrivilegesToJSON,
    PrivilegesRequest,
    PrivilegesRequestFromJSON,
    PrivilegesRequestToJSON,
} from '../models';

export interface GetPrivilegesRequest {
    privilegesRequest?: PrivilegesRequest;
}

export interface LoginOperationRequest {
    loginRequest?: LoginRequest;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     */
    async getPrivilegesRaw(requestParameters: GetPrivilegesRequest): Promise<runtime.ApiResponse<Privileges>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/privileges`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrivilegesRequestToJSON(requestParameters.privilegesRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PrivilegesFromJSON(jsonValue));
    }

    /**
     */
    async getPrivileges(requestParameters: GetPrivilegesRequest): Promise<Privileges> {
        const response = await this.getPrivilegesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async loginRaw(requestParameters: LoginOperationRequest): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestToJSON(requestParameters.loginRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     */
    async login(requestParameters: LoginOperationRequest): Promise<LoginResponse> {
        const response = await this.loginRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async logoutRaw(): Promise<runtime.ApiResponse<LogoutResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/logout`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LogoutResponseFromJSON(jsonValue));
    }

    /**
     */
    async logout(): Promise<LogoutResponse> {
        const response = await this.logoutRaw();
        return await response.value();
    }

}
